import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69802719921dc90014f0aa38/website_project/src/app/settlement-center/offer-builder/components/OfferBuilderInteractive.tsx");
